var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Height",
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.459,
    height: 40.246,
    viewBox: "0 0 37.459 40.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M36.4,24.276a2.116,2.116,0,0,1-2.882-.773L31.6,20.169c0,5.4.069,12.243.069,17.654a2.42,2.42,0,0,1-4.841,0V27.162H25.465V37.826a2.42,2.42,0,1,1-4.841,0c0-5.385.062-12.2.062-17.572L18.81,23.506A2.11,2.11,0,0,1,15.155,21.4l4.91-8.5C21.816,9.862,30.306,9.488,32.2,12.76L37.181,21.4a2.117,2.117,0,0,1-.776,2.879ZM8.437,29.726a.623.623,0,1,1,0-1.231h2.352V25.036h-4.9a.623.623,0,1,1,0-1.231h4.9V19.953H8.437a.623.623,0,1,1,0-1.231h2.352V15.191h-4.9a.623.623,0,1,1,0-1.231h4.9V10.242H8.437a.669.669,0,0,1-.714-.616.671.671,0,0,1,.714-.616h2.352V5.342h-4.9a.669.669,0,0,1-.714-.616.671.671,0,0,1,.714-.616h4.9V1.448H1.248V38.324h9.541V34.685h-4.9a.623.623,0,1,1,0-1.231h4.9V29.726ZM.685.2H11.352a.668.668,0,0,1,.481.2.681.681,0,0,1,.2.481v38a.694.694,0,0,1-.685.685H.685a.668.668,0,0,1-.481-.2.668.668,0,0,1-.2-.481v-38A.668.668,0,0,1,.2.4.668.668,0,0,1,.685.2ZM26.163,0a4.831,4.831,0,1,1-4.831,4.831A4.829,4.829,0,0,1,26.163,0Z",
    fill: "#3e3e3e",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeight);
export default __webpack_public_path__ + "static/media/Height.29e80bbdd0bee8b79f8006ba0750372f.svg";
export { ForwardRef as ReactComponent };